import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Door = (props: Icon): React.ReactElement => (
  <svg
    style={{ ...style(props.size, props.height), ...props.style }}
    viewBox="0 0 40 48"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        transform="translate(-596.000000, -1020.000000)"
        fill={props.color || theme.palette.grey600}
        fillRule="nonzero"
      >
        <g transform="translate(178.000000, 818.000000)">
          <g transform="translate(0.000000, 100.000000)">
            <g transform="translate(418.000000, 102.000000)">
              <path d="M38,44 C39.1,44 40,44.9 40,46 C40,47.1 39.1,48 38,48 L38,48 L2,48 C0.9,48 0,47.1 0,46 C0,44.9 0.9,44 2,44 L2,44 Z M36,8 L36,40 L4,40 L4,25 L10.6,25 C10.82,25 11,24.325 11,23.5 C11,22.675 10.82,22 10.6,22 L4,22 L4,8 L36,8 Z M38,0 C39.1,0 40,0.9 40,2 C40,3.1 39.1,4 38,4 L38,4 L2,4 C0.9,4 0,3.1 0,2 C0,0.9 0.9,0 2,0 L2,0 Z"></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
);
